<template>
  <div>
    <v-container class="ml-10 mr-10 message-container">
      <p class="display-1 mt-7">{{ appCode !== "cert_digital" ? "카톡/" : "" }}SMS/메일 발송 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쇼핑몰에서 고객이
        {{ appCode !== "cert_digital" ? "결제완료, 배송완료, 정품 인증이 완료되었을때 카톡/" : "디지털 상품을 결제시 " }}SMS/메일 발송을 할
        수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light" v-if="appCode !== 'cert_digital'">
        카카오톡 비즈니스 채널을 생성하여야 사용이 가능하며, 발송 포인트를 충전하여 사용이 가능합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        {{ appCode !== "cert_digital" ? "카톡+SMS+메일 발송 연동시 1건당 22포인트가 차감되며, " : "" }}SMS은 카페24 관리자와 연동하여
        발송하므로 카페24 SMS 잔여건수에서 차감됩니다.
      </p>

      <div>
        <v-card outlined class="mt-10 ml-0 mr-10  px-3 d-flex justify-space-between">
          <div class="d-flex justify-start align-center pl-5">
            발송 타입
            <v-card-subtitle class="pl-8">
              {{ sendingType | sendTypeText }}
            </v-card-subtitle>
          </div>
          <div class="justify-end d-flex align-center" v-if="appCode !== 'cert_digital'">
            <v-card-subtitle class="pr-8">
              잔여 포인트: <span class="underline" @click="chargePoint">{{ remain_points | numberFormat }} P </span>
            </v-card-subtitle>
            <v-btn class="info" small @click="chargePoint">
              포인트 충전하기
            </v-btn>
          </div>
        </v-card>
      </div>

      <v-tabs class="mt-10 col-12 ml-0 mr-10 pl-0">
        <v-tab class="title">{{ isAllowedKakao ? "카톡/" : "" }}SMS/메일 발송 설정</v-tab>
        <v-tab-item class="pl-0">
          <MessageSetting ref="MessageManage" :sendingType="sendingType" @update="saveSetType"></MessageSetting>
        </v-tab-item>

        <v-tab class="title">{{ isAllowedKakao ? "카톡/" : "" }}SMS/메일 발송 내역</v-tab>
        <v-tab-item>
          <SendingHistoryList ref="MessageManage"></SendingHistoryList>
        </v-tab-item>

        <v-tab class="title" v-if="appCode !== 'cert_digital'">발송 포인트 소진 내역</v-tab>
        <v-tab-item>
          <MinusPointList ref="MessageManage"></MinusPointList>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>
<style scoped>
.underline {
  text-decoration: underline;
  cursor: pointer;
}

.message-container {
  max-width: 1580px !important;
}
</style>

<script>
import M from "@/libs/mapping.js";
import MessageSetting from "@/components/authservice/message/MessageSetting.vue";
import SendingHistoryList from "@/components/authservice/message/SendingHistoryList.vue";
import MinusPointList from "@/components/authservice/message/MinusPointList.vue";
import Filters from "@/libs/authservice/filters.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      sendingType: "",
      remain_points: 0,
    };
  },
  computed: {
    appCode() {
      // store에서 appCode 값을 가져옴 (없으면 cert_product가 기본값)
      return this.$store.state.appCode || "cert_product";
    },
    isAllowedKakao() {
      return this.isAllowedKakaoForDigital();
    },
  },
  methods: {
    saveSetType: function(setType) {
      this.sendingType = setType;
    },
    getSendType: async function() {
      const res = await M.api(M.entry("/get/config/message/send_type"));
      this.sendingType = res.sending_type;
      this.remain_points = res.remain_points;
      this.$store.commit("UPDATE_POINT", this.remain_points);
    },
    chargePoint: function() {
      this.$router.push({ name: "Payment", query: { type: "point" } }, { replace: true });
    },
  },
  components: {
    MessageSetting,
    SendingHistoryList,
    MinusPointList,
  },
  filters: Filters,
  created: async function() {
    await this.waitForShopNo();
    this.getSendType();
  },
};
</script>
